import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaMapMarkerAlt, FaPhone } from 'react-icons/fa';
import { IoLogoInstagram, IoLogoYoutube } from 'react-icons/io';
import footerLogo from '../../assets/images/footerlogo.png';
import styles from './footer.module.css';
import aparat from '../../assets/images/aparatimg.png'
const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerColumnLogo}>
        <img src={footerLogo} alt="Logo" className={styles.logo} />
        <div className={styles.socialContainer}>
          <a href='https://www.instagram.com/helium_park_iran/' target='_blank' className={styles.socialLink}>
            <IoLogoInstagram />
          </a>
          <a href='https://www.youtube.com/@heliumpark-iran/featured' target='_blank' className={styles.socialLink}>
            <IoLogoYoutube />
          </a>
          <a href='https://www.aparat.com/heliumpark_iran' target='_blank' className={styles.socialLink}>
            <img src={aparat} alt="Logo" className={styles.aparat} />
          </a>
        </div>
      </div>
      <div className={styles.footerColumnrow}>
        <div className={styles.footerColumnMenu}>
          <h4 className={styles.menuHeader}>دسترسی‌سریع</h4>
          <li><a href='/games' className={styles.menuLink}>معرفی بازی‌ها</a></li>
          <li><a href='/virtual' className={styles.menuLink}>تور مجازی</a></li>
          <li><a href='/calculator' className={styles.menuLink}>تعرفه</a></li>
          <li><a href='/birthday' className={styles.menuLink}> اتاق تولد</a></li>
        </div>
        <div className={styles.footerColumnContact}>
          <h4 className={styles.contactHeaer}>تماس با ما</h4>
          <ul>
            <li>
              <FaMapMarkerAlt />
              <span className={styles.spanText}>مشهد،بلوار جانباز، برج مروارید</span>
            </li>
            <li>
              <FaMapMarkerAlt />
              <span> تهران، ایرانمال، طبقه G1</span>
            </li>
            <li>
              <FaPhone />
              <span>۰۵۱۳۱۴۳۹</span>
            </li>
            {/* <li>
              <FaPhone />
              <span>۰۹۰۲۰۰۳۱۴۳۹</span>
            </li> */}
          </ul>
        </div>
      </div>
      <div className={styles.footerColumn}>
        <iframe className={styles.mapMain} src="https://map.ir/lat/36.329741/lng/59.562278/z/18/p/%D9%85%D8%A7%20%D8%A7%DB%8C%D9%86%D8%AC%D8%A7%DB%8C%DB%8C%D9%85"></iframe>
      </div>
    </footer>
  );
};
export default Footer;